import { POST_METHOD, PUT_METHOD, DELETE_METHOD, Request } from '@/lib/http';
import store from '@/store';
import AuthEnum from '../lib/enums/auth-enum';

const baseURL = '/api/identity';

export default {
  exchangeToken(exchangeData) {
    const request = new Request(`${baseURL}/auth/exchange`, {
      method: POST_METHOD,
      body: exchangeData,
      authType: AuthEnum.FIREBASE,
    });
    return request.send();
  },
  getTenantSession(tenantId) {
    const request = new Request(`${baseURL}/auth/exchange/t/${tenantId}`, {
      method: POST_METHOD,
    });
    return request.send();
  },
  getClaimsToken() {
    const request = new Request(`${baseURL}/claims_token`, {
      withoutClaims: true,
      preventAbort: true,
      authType: AuthEnum.FIREBASE,
    });
    return request.send();
  },
  getClaimsTokenWithTenant(tenantId) {
    const request = new Request(`${baseURL}/claims_token/${tenantId}`, {
      authType: AuthEnum.FIREBASE,
      preventAbort: true,
    });
    return request.send();
  },
  getLastUserActivity() {
    const tenantId = store.getters.tenant.id;
    const request = new Request(`${baseURL}/${tenantId}/auth/tenant_token/decoded`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  getTenantProvider(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/provider`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  getUserClaims() {
    const request = new Request(`${baseURL}/claims_token/commands/read`, {
      authType: AuthEnum.FIREBASE,
    });
    return request.send();
  },
  getUserTenants() {
    const request = new Request(`${baseURL}/user/tenants`, {
      authType: AuthEnum.USER,
    });
    return request.send();
  },
  getUserProvider(email) {
    const request = new Request(`${baseURL}/user/${email}/provider`, { authType: AuthEnum.WITHOUT });
    return request.send();
  },
  postLogin() {
    const request = new Request(`${baseURL}/commands/login`, {
      method: POST_METHOD,
      authType: AuthEnum.FIREBASE,
    });
    return request.send();
  },
  postLogout(authConfig) {
    const request = new Request(`${baseURL}/commands/logout/${authConfig}`, { method: POST_METHOD });
    return request.send();
  },
  postTenantProvider(tenantId, createData) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/provider`, {
      body: createData,
      method: POST_METHOD,
      authType: AuthEnum.TENANT,
      preventAbort: true,
    });
    return request.send();
  },
  putTenantProvider(tenantId, updateData) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/provider`, {
      body: updateData,
      method: PUT_METHOD,
      authType: AuthEnum.TENANT,
      preventAbort: true,
    });
    return request.send();
  },
  deleteTenantProvider(tenantId) {
    const request = new Request(`${baseURL}/${tenantId}/tenant/provider`, {
      method: DELETE_METHOD,
      authType: AuthEnum.TENANT,
      preventAbort: true,
    });
    return request.send();
  },
};
